document.addEventListener( 'DOMContentLoaded', function () {
	const container = document.querySelector( '.articles-slide' );
	if ( ! container ) {
		return;
	}

	const dots = document.querySelectorAll( '.slider-dot' );
	const articles = container.querySelectorAll( '.article-card' ); // adjust selector if needed

	if ( ! dots.length || ! articles.length ) {
		return;
	}

	dots.forEach( dot => {
		dot.addEventListener( 'click', function () {
			const index = parseInt( this.getAttribute( 'data-slide' ), 10 );

			if ( articles[ index ] ) {
				const scrollLeft = articles[ index ].offsetLeft;

				container.scrollTo( {
					left: scrollLeft,
					behavior: 'smooth',
				} );

				// Update active class on dots
				dots.forEach( d => d.classList.remove( 'active' ) );
				this.classList.add( 'active' );
			}
		} );
	} );

	// Optional: Update dots based on scroll position
	container.addEventListener( 'scroll', function () {
		let activeIndex = 0;
		articles.forEach( ( article, index ) => {
			if ( article.offsetLeft - container.scrollLeft < article.offsetWidth / 2 ) {
				activeIndex = index;
			}
		} );

		dots.forEach( d => d.classList.remove( 'active' ) );
		if ( dots[ activeIndex ] ) {
			dots[ activeIndex ].classList.add( 'active' );
		}
	} );
} );